import { render, staticRenderFns } from "./TermometriaProdutoLista.vue?vue&type=template&id=4ba85da6&"
import script from "./TermometriaProdutoLista.vue?vue&type=script&lang=js&"
export * from "./TermometriaProdutoLista.vue?vue&type=script&lang=js&"
import style0 from "./TermometriaProdutoLista.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports